{
  "login": {
    "title": "Sign in",
    "intro": "Staff account for the shop back office.",
    "email": "Email",
    "password": "Password",
    "show_password": "Show password",
    "hide_password": "Hide password",
    "caps_lock": "Caps Lock is on",
    "submit": "Sign in",
    "submitting": "Signing in…",
    "forgot": "Forgot your password?",
    "dev_bypass_hint": "Development mode: any email and password will sign you in."
  },
  "totp": {
    "title": "Enter the 6-digit code",
    "intro": "Open your authenticator app (Google Authenticator, 1Password…) and type the code shown for this shop.",
    "code": "6-digit code",
    "submit": "Continue",
    "use_recovery": "Use a backup code instead",
    "use_app": "Use the code from the app",
    "recovery_code": "Backup code",
    "recovery_intro": "Type one of the backup codes you printed or saved when you set up the app. Each code works once.",
    "back": "Back to sign in"
  },
  "setup": {
    "title": "Protect your account with a code app",
    "intro": "Owners and managers need a second step when they sign in. It takes about 2 minutes.",
    "step1_title": "1. Install an authenticator app",
    "step1_body": "On your phone, install Google Authenticator, Microsoft Authenticator or 1Password (all free).",
    "step2_title": "2. Scan this picture with the app",
    "step2_body": "In the app, tap \"+\" and choose \"Scan a QR code\".",
    "qr_alt": "QR code to add this shop to your authenticator app",
    "manual": "Cannot scan? Type this key into the app instead:",
    "copy_secret": "Copy key",
    "copied": "Copied",
    "step3_title": "3. Type the 6-digit code the app shows",
    "code": "6-digit code",
    "submit": "Check the code",
    "loading": "Preparing your QR code…",
    "codes_title": "Save your backup codes",
    "codes_intro": "If you lose your phone, each of these codes lets you sign in once. Download them and keep them somewhere safe (not on the same phone).",
    "download": "Download the backup codes",
    "print": "Print",
    "downloaded": "Downloaded — keep the file somewhere safe.",
    "must_download": "Download the backup codes first — you cannot see them again.",
    "confirm_saved": "I have saved the backup codes",
    "continue": "Continue to the shop admin",
    "file_heading": "Backup codes for the shop admin — each code works once",
    "done": "Two-step sign-in is on"
  },
  "change": {
    "title": "Choose a new password",
    "intro": "This is your first sign-in with a temporary password. Choose your own password to continue.",
    "current": "Temporary password",
    "current_profile": "Current password",
    "new": "New password",
    "confirm": "New password again",
    "submit": "Save the new password",
    "mismatch": "The two new passwords are not the same",
    "saved": "Password changed. Your other devices were signed out."
  },
  "strength": {
    "label": "Password strength",
    "rule": "At least 12 characters. A short sentence is easy to remember.",
    "too_short": "Too short — {{count}} more characters",
    "weak": "Weak",
    "fair": "OK",
    "strong": "Strong"
  },
  "forgot": {
    "title": "Reset your password",
    "intro": "Type the email of your staff account. We send a link to choose a new password.",
    "email": "Email",
    "submit": "Send the link",
    "sent_title": "Check your email",
    "sent_body": "If this email belongs to a staff account, a link is on its way. It works for 30 minutes.",
    "back": "Back to sign in"
  },
  "reset": {
    "title": "Choose a new password",
    "missing_token": "This link is incomplete. Open the link from the email again, or ask for a new one.",
    "submit": "Save the new password",
    "done_title": "Password saved",
    "done_body": "You can now sign in with the new password.",
    "sign_in": "Sign in",
    "ask_again": "Send a new link"
  },
  "expired": {
    "title": "Time is up — please sign in again",
    "body": "For safety you were signed out. What you typed on this page is kept as a draft and comes back after you sign in.",
    "sign_in": "Sign in again"
  },
  "profile": {
    "title": "My account",
    "intro": "Your sign-in, language and devices.",
    "details": "About me",
    "name": "Name",
    "role": "Role",
    "language": "Language of the admin",
    "language_hint": "Only for you — other staff keep their own language. Saved on this device.",
    "language_saved": "Language changed",
    "password_title": "Password",
    "password_change": "Change password",
    "password_saved": "Password changed. Your other devices were signed out.",
    "two_step": "Two-step sign-in (code app)",
    "two_step_on": "On",
    "two_step_off": "Off",
    "two_step_turn_on": "Turn on",
    "sessions_title": "Where you are signed in",
    "sessions_intro": "Every browser or phone where your account is open.",
    "this_device": "This device",
    "last_used": "Last used {{time}}",
    "signed_in_at": "Signed in {{time}}",
    "unknown_device": "Unknown browser",
    "sign_out_others": "Sign out on all other devices",
    "sign_out_others_title": "Sign out on all other devices?",
    "sign_out_others_body": "Every other browser and phone must sign in again. This device stays signed in.",
    "signed_out_others_one": "Signed out on {{count}} other device",
    "signed_out_others_other": "Signed out on {{count}} other devices",
    "no_other_sessions": "No other devices"
  },
  "errors": {
    "invalid": "Email or password is incorrect.",
    "not_available": "Sign-in is not connected yet. Staff accounts arrive with the identity service.",
    "locked": "Too many wrong tries — the account is paused for now.",
    "locked_retry": "Too many wrong tries — try again in {{minutes}} min, or ask the owner.",
    "rate_limited": "Too many tries in a short time — wait a moment.",
    "rate_limited_retry": "Too many tries — try again in {{minutes}} min.",
    "code_invalid": "The code is not correct. Check the app and type the newest code.",
    "challenge_expired": "This step took too long. Please start again from the email and password.",
    "weak_password": "Choose a longer password (at least 12 characters, not a common one).",
    "network": "Cannot reach the shop system — check the internet connection.",
    "unknown": "Sign-in did not work. Please try again."
  },
  "invite": {
    "title": "Choose your password",
    "intro": "Welcome, {{name}}. You sign in with {{email}}.",
    "two_step": "After the password you set up two-step sign-in with an authenticator app on your phone — keep your phone at hand.",
    "valid_until": "This link works once, until {{until}} (Japan time).",
    "submit": "Save and continue",
    "missing": "This link is incomplete. Open the link from the invitation e-mail again.",
    "used_or_expired": "This invitation link was already used or has expired. Ask the owner to send the invitation again.",
    "sign_in_now": "Your password is saved. Sign in with your e-mail and the new password.",
    "to_login": "Go to sign-in"
  }
}
